import React from "react";
import { Link, useParams } from "react-router-dom";
import {
  EditOutlined,
} from "@mui/icons-material";
import { Box, Button, Divider } from "@mui/material";

import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetVendorStaffDetailQuery } from "store/services/vendorStaffApi";
import AppConfirmDialog from "components/Shared/AppConfirmDialog";
import { toast } from "react-toastify";
import {
  useDetailUserQuery,
  useEditAccountUserMutation,
} from "store/services/userApi";
import VendorStaffBasicDetail from "./VendorStaffComponents/VendorStaffBasicDetail";
import { VendorStaffDetailContext } from "contexts/VendorStaffDetailContext";
// import { VendorStaffDetailTabs } from "./VendorStaffComponents/VendorStaffDetailTabs";

const VendorStaffDetailScreen = () => {
  const { id } = useParams();
  const breadcrumbs = [
    { title: "Vendor Staff", path: "/app/vendor/staffs/list" },
    { title: "Vendor Staff Detail" },
  ];

  const { data: vendorStaffDetail, isLoading: loadingVendorStaffDetail } =
    useGetVendorStaffDetailQuery(id);

  return (
        <VendorStaffDetailContext.Provider
          value={{
            vendorStaffDetail,
            loadingVendorStaffDetail: loadingVendorStaffDetail
          }}
        >
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingVendorStaffDetail}
      headerActions={
        !loadingVendorStaffDetail && vendorStaffDetail?.connectedUser ? (
          <PageActions
            userId={vendorStaffDetail.connectedUser._id}
            userName={vendorStaffDetail.connectedUser.name}
          />
        ) : null
      }
    >
      {!loadingVendorStaffDetail ? (
        <BreadcrumbLayout.Paper>
        <VendorStaffBasicDetail/>
        <Divider />

        {/* <VendorStaffDetailTabs/> */}
        </BreadcrumbLayout.Paper>
      ) : (
        <InfoGridSkeleton />
      )}
    </BreadcrumbLayout>
    </VendorStaffDetailContext.Provider>
  );
};

export default VendorStaffDetailScreen;

// Page Actions with props
const PageActions = ({ userId, userName }) => {
  const { id } = useParams();

  return (
    <Box display="flex" gap={2}>
      <ToggleUserStatus userId={userId} userName={userName} />
      <Link to={`/app/vendor/staffs/${id}/edit`}>
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      </Link>
    </Box>
  );
};

// Toggle user status for connected user
const ToggleUserStatus = ({ userId, userName }) => {
  const [showDialog, setShowDialog] = React.useState(false);

  const { data: userDetail, isLoading } = useDetailUserQuery(userId);
  const [updateAccountUser, { isLoading: updatingUser }] = useEditAccountUserMutation();

  const userToggleStatus = userDetail?.isActive ? "Deactivate" : "Activate";

  const handleUpdateUserStatus = async () => {
    try {
      await updateAccountUser({
        id: userDetail?._id,
        isActive: !userDetail?.isActive,
      }).unwrap();
      toast.info(`User successfully ${userDetail?.isActive ? "Disabled" : "Enabled"}!`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update user status!");
    } finally {
      setShowDialog(false);
    }
  };

  if (isLoading) return null;

  return (
    <>
      <Button
        variant="outlined"
        color={userDetail?.isActive ? "error" : "success"}
        disabled={updatingUser}
        onClick={() => setShowDialog(true)}
      >
        {userToggleStatus}
      </Button>

      <AppConfirmDialog
        open={showDialog}
        title={`${userToggleStatus} ${userName}?`}
        loading={updatingUser}
        onConfirm={handleUpdateUserStatus}
        onClose={() => setShowDialog(false)}
      >
        <div>
          Are you sure you want to <span>{userToggleStatus}</span>{" "}
          <span className="font-medium text-blue-600 dark:text-blue-200">
            {userName}?
          </span>
        </div>
      </AppConfirmDialog>
    </>
  );
};
